import React, { useEffect, useState } from 'react';
import { Box, Typography, Paper, CircularProgress } from '@mui/material';
import axios from 'axios';

const ResultsSummary = ({ batchId }) => {
  const [summary, setSummary] = useState('');
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    console.log('reaching oout to summary endpoint')
    console.log(process.env.REACT_APP_BACKEND_URL + `summarise_results/${batchId}`)
    if (!batchId) return;

    setLoading(true);
    setError('');

    axios
      .get(process.env.REACT_APP_BACKEND_URL + `summarise_results/${batchId}`)
      .then((response) => {
        const data = response.data;
        if (typeof data === 'string') {
          setSummary(data);
        } else if (data?.summary) {
          setSummary(data.summary);
        } else {
          setSummary('');
        }
      })
      .catch((err) => {
        console.error('Error fetching summary:', err);
        setError('Failed to load summary.');
      })
      .finally(() => {
        setLoading(false);
      });
  }, [batchId]);

  return (
    <Box sx={{ padding: 3 }}>
      <Typography variant="h5" gutterBottom>
        Results Summary
      </Typography>

      {loading ? (
        <Box sx={{ textAlign: 'center', mt: 4 }}>
          <CircularProgress />
          <Typography variant="body2" sx={{ mt: 2 }}>
            Loading summary...
          </Typography>
        </Box>
      ) : error ? (
        <Typography variant="body1" color="error">
          {error}
        </Typography>
      ) : summary ? (
        <Paper
          elevation={2}
          sx={{
            padding: 3,
            backgroundColor: '#fafafa',
            whiteSpace: 'pre-wrap',
            fontSize: '1rem',
            lineHeight: 1.6,
          }}
        >
          {summary}
        </Paper>
      ) : (
        <Typography variant="body1" color="text.secondary">
          No summary available.
        </Typography>
      )}
    </Box>
  );
};

export default ResultsSummary;